import React, { useEffect, useState } from 'react';
import Button from '../../FlyfishComponents/Button';
import ImageDisplay from './ImageDisplay';
import ImageDescription from './ImageDescription';
import Variant from './Variant';
import Axios from 'axios';
import {
	getCurrencySymbol,
	loadStateSession,
} from '../../FlyfishComponents/flyfishutils/utils';

type Props = {
	// handleSubmit: Function;
	// WorkflowData: any;
	colorMode: string;
	colorScale: string;
	productData: any;
	getProductDetails: Function;
	createCart: Function;
	handleSubmit: Function;
	handleSelectedProduct?: Function;
	productId: string;
	productName: string;
	showComplementary?: Function;
	setProductId?: Function;
	setProductName?: Function;
	tenantId?: string;
	token?: string;
	lists;
	// token: any;
	// botId: any;
	// tenantId: any;
	// conversationId: any;
	// cssPtag?: any;
	// addUserResponse: Function;
	// currentWorkflow: string;
	// changeScreen?: Function;
	// showToaster?: Function;
	// disableMandatory?: Function;
	// shouldDisableActions?;
};

const ShowComplementaryDesc = ({
	// handleSubmit,
	// WorkflowData,
	// colorMode,
	// botId,
	// tenantId,
	// token,
	// conversationId,
	// cssPtag,
	// changeScreen,
	// addUserResponse,
	// currentWorkflow,
	// showToaster,
	// disableMandatory,
	// shouldDisableActions
	colorMode,
	colorScale,
	productData,
	getProductDetails,
	handleSelectedProduct,
	handleSubmit,
	createCart,
	productId,
	productName,
	showComplementary,
	setProductId,
	tenantId,
	setProductName,
	token,
	lists
}: Props) => {
	const [selectedProduct, handleProduct] = useState<any>({});

	const displaySymbol = (currencyCode) => {
		return <>{getCurrencySymbol(currencyCode)}</>;
	};
	useEffect(() => {
		Axios.get(
			`${
				window['BASE_URL']
			}/shop/${tenantId}/product?productId=${productId}&country=${loadStateSession(
				'FS-countryCode'
			)}`,
			{
				headers: {
					'x-tenant-id': tenantId,
					Authorization: `Bearer ${token}`,
				},
			}
		).then((resp: any) => {
			handleProduct(resp.data.response);

			setTimeout(() => {
				const chatbodyWrapper = document.querySelector('.sf-chatbody');
				chatbodyWrapper.scrollTo({
					top: chatbodyWrapper.scrollHeight - 100,
					behavior: 'smooth',
				});
			}, 100);
		});
		handleSelectedProduct({ productID: productId, productName: productName });
	}, [productId]);

	const [selectedIndex, handleSelected] = useState(0);
	const [reason, handleReason] = useState('');

	return (
		<div className='ff-productDisplay-content'>
			<div className='ff-carousel-border'></div>
			<div className={`ff-productDisplay-right ff-no-complementary`}>
				<div className='ff-product-display-desc-cart'>
					<div className='ff-product-image-desc'>
						<ImageDisplay
							images={
								selectedProduct.data && selectedProduct.data.variants[0].image
							}
							// title={lists.items[selectedIndex].title}
							// isReason={
							// 	lists.items[selectedIndex] &&
							// 	lists.items[selectedIndex].reason_query.length !=
							// 		0 &&
							// 	lists.items[selectedIndex] &&
							// 	lists.items[selectedIndex].reason.length > 0
							// 		? true
							// 		: false
							// }
							// ffstore={false}
						/>
					</div>

					<div className={`ff-cart-desc ${colorMode}`}>
						<div>
							<div
								className='ff-cart-desc-title'
								dangerouslySetInnerHTML={{
									__html:
										selectedProduct &&
										selectedProduct.data &&
										selectedProduct.data.title.replace(/\n/g, '<br />'),
								}}
								style={{ fontSize: '16px', fontWeight: 'bold' }}
							></div>
							<div className='ff-related-image-price'>
								{selectedProduct &&
									selectedProduct.data &&
									selectedProduct.data.variants.length > 0 && selectedProduct.data && selectedProduct.data.variants[0].price !== '0' &&
								<>
								{displaySymbol(selectedProduct.data.variants[0].currency)}
									{' '}
								{selectedProduct.data && selectedProduct.data.variants[0].price}
								</>	
                                 }
							</div>

							<div
								className={`ff-product-image-related-content-title ${colorMode}`}
							>
								Description
							</div>
							<ImageDescription
								title={selectedProduct.data && selectedProduct.data.title}
								price={
									selectedProduct.data && selectedProduct.data.variants[0].price
								}
								currencyCode={
									selectedProduct.data &&
									selectedProduct.data.variants[0].currency
								}
								desc={selectedProduct.data && selectedProduct.data.description}
							/>
						</div>
						{selectedProduct.data &&
							selectedProduct.data.variants[0].price &&
							selectedProduct.data.variants[0].price !== '0' && (
								<Button
									buttonType={colorMode == 'dark' ? 'dark' : 'light'}
									onClick={() => {
										//createCart(selectedProduct.data.product.variants[0].admin_graphql_api_id,)
									}}
								>
									Add to Cart
								</Button>
							)}

						<Variant colorMode={colorMode} />
						<div className='ff-protection-plans'></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ShowComplementaryDesc;
